//record containing embark colors used throughout app
export const embarkColors = {
    blue: 'rgb(0,99,168)',
    gray: 'rgb(217,217,217)',
    green: 'rgb(82,218,105)',
    red: 'rgb(255,65,54)',
    black: 'rgb(16,16,16)',
    orange: 'rgb(255,152,8)',

    blue50: 'rgb(0,99,168, .5)',
    gray50: 'rgb(217,217,217, .5)',
    green50: 'rgb(82,218,105, .5)',
    red50: 'rgb(255,65,54, .5)',
    black50: 'rgb(16,16,16, .5)',
    orange50: 'rgb(255,152,8, .5)',

    blue75: 'rgb(0,99,168, .75)',
    gray75: 'rgb(217,217,217, .75)',
    green75: 'rgb(82,218,105, .75)',
    red75: 'rgb(255,65,54, .75)',
    black75: 'rgb(16,16,16, .75)',
    orange75: 'rgb(255,152,8, .75)'
} as const;

export type EmbarkColorKey = keyof typeof embarkColors;
export type EmbarkColorValue = (typeof embarkColors)[EmbarkColorKey];
